<template>
  <div class="days-view margin-bottom-ml margin-top-ml">
    <day
      v-for="(date, index) in dateArray"
      :key="index"
      :date="date"
      :disabled="disabled"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import Day from './Day.vue';
import { enumerateDaysBetweenDates } from '../../utils/date';

interface Props {
  startDate: Date,
  endDate: Date,
  disabled: boolean
}
const props = defineProps<Props>();
const dateArray = computed(() => enumerateDaysBetweenDates(props.startDate, props.endDate));

</script>

<style lang="scss" scoped>
@import 'base-ui-vue3/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/spacings';

.days-view {
  display: flex;
  justify-content: center;
  gap: $ri-spacing-xs;
}
</style>
